import {
  ErrorHandler,
  Injectable,
  Injector,
  ApplicationRef,
  ChangeDetectorRef,
} from "@angular/core";
import { FullLoaderService } from "./full-loader.service";

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  errorCount = 0;

  constructor(protected injector: Injector, private fullLoaderService: FullLoaderService) {
    super();
  }
  // https://github.com/angular/angular/issues/17010
  override handleError(error: any) {
    // --- Self-heal from stale lazy-chunk references (ChunkLoadError) ---
    // A tab opened before a new build/deploy still references the OLD chunk
    // filenames. Navigating to a lazily-loaded route (e.g. /settings) then
    // requests a chunk that no longer exists -> 404 -> ChunkLoadError, and the
    // route never loads (the page looks "crashed"). A fresh window works
    // because it reloads index.html and gets current chunk names. Detect this
    // and reload once to pull the current bundle. The 10s timestamp guard
    // allows recovery across repeated rebuilds while preventing a reload loop
    // if a chunk is genuinely missing.
    const chunkLoadFailed =
      /ChunkLoadError|Loading chunk [\w./-]+ failed|Failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed/i;
    const message = (error && (error.message || error.toString())) || "";
    if (chunkLoadFailed.test(message)) {
      try {
        const now = Date.now();
        const last = Number(sessionStorage.getItem("__chunkReloadAt") || 0);
        if (now - last > 10000) {
          sessionStorage.setItem("__chunkReloadAt", String(now));
          window.location.reload();
          return;
        }
      } catch {
        /* sessionStorage unavailable — fall through to normal handling */
      }
    }

    let increment = 5;
    let max = 50;

    // Prevents change detection
    let debugCtx = error["ngDebugContext"];
    let changeDetectorRef =
      debugCtx && debugCtx.injector.get(ChangeDetectorRef);
    if (changeDetectorRef) changeDetectorRef.detach();

    this.errorCount = this.errorCount + 1;
    //console.log("IN ERROR HANDLER");

    // Close all open dialogs on error (loading dialogs).
    this.fullLoaderService.hideLoader();

    if (this.errorCount % increment === 0) {
      //console.log(`errorHandler() was called ${this.errorCount} times.`);
      super.handleError(error);

      if (this.errorCount === max) {
        console.log(
          `Preventing recursive error after ${this.errorCount} recursive errors.`
        );
        let appRef = this.injector.get(ApplicationRef);
        appRef.tick();
      }
    } else if (this.errorCount === 1) {
      super.handleError(error);
    }
  }
}
